/** Debounce (ms) before the URL is committed after the user stops typing. */
export const LINK_INPUT_DEBOUNCE_MS = 1000;

export const LINK_INPUT_MAX_LENGTH = 2000;
